module.exports = __webpack_public_path__ + "static/media/nizoral.96706ff6.png";